
export default class Geslacht {
    aanduiding: string;
    constructor(init?:Partial<Geslacht>) {
        Object.assign(this, init);
    }
}
